module.exports = __webpack_public_path__ + "static/media/dot_F77935.5f8ed761.svg";